import { useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter, browserHistory } from 'react-router'
import { getActiveLanguage, getTranslate, getLanguages } from 'react-localize-redux'
import cx from 'classnames'

import { withStyles, StylesProvider } from '@material-ui/core/styles'
import { AppBar, Toolbar, MenuItem, Menu, Fade, Button, Icon, SvgIcon } from '@material-ui/core'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp'
import PersonOutlineIcon from '@material-ui/icons/PersonOutline'
import MenuIcon from '@material-ui/icons/Menu'
import Typography from '@material-ui/core/Typography'
import ExitToAppOutlinedIcon from '@material-ui/icons/ExitToAppOutlined'

import * as ModalTypes from 'constants/ModalTypes'
import { getUser, getUserLang } from 'common/selectors/user'
import { getSystemsRaw } from 'common/selectors/systems'
import { setActiveLanguage } from 'common/actions/localize'
import { showModal, hideModal } from 'common/actions/modal'
import styles from './AuxHeader.module.scss'
import * as Routes from 'constants/Routes'
import { InbiotLogo } from 'icons'
import { ReactComponent as ManageAccountsIcon } from 'icons/manage_accounts.svg'
import { ReactComponent as Environment } from 'icons/environment.svg'

const AuxHeader = props => {
  const [helpAnchorEl, setHelpAnchorEl] = useState(null)
  const [userAnchorEl, setUserAnchorEl] = useState(null)

  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false)

  const { systems } = props

  const user = props.user?.toJS()

  let systemsJS = []
  systems.toArray().map(s => systemsJS.push(s.toJS()))

  const redirect = route => {
    browserHistory.push(route)
  }

  const openMobileMenu = () => {
    if (!isMobileMenuOpen) {
      setMobileMenuOpen(true)
    } else {
      setMobileMenuOpen(false)
    }
  }

  const closeMobileMenu = () => {
    setMobileMenuOpen(false)
  }

  const handleMenuHelpOpen = event => {
    window.open('https://www.orkli.com/en/contact', '_blank')
  }

  const handleMenuUserOpen = event => {
    if (userAnchorEl) {
      setUserAnchorEl(null)
    } else {
      setUserAnchorEl(event.currentTarget)
    }
  }

  const handleHelpClick = option => {
    switch (option) {
      case 'use-info':
        window.open('https://www.orkli.com/en/contact', '_blank')
        setHelpAnchorEl(null)
        break
      case 'faqs':
        window.open('https://www.orkli.com/en/contact', '_blank')
        setHelpAnchorEl(null)
        break
      case 'contact':
        window.open('https://www.orkli.com/en/contact', '_blank')
        setHelpAnchorEl(null)
        break
      default:
        break
    }
  }

  const handleUserClick = option => {
    switch (option) {
      case 'edit-profile':
        setUserAnchorEl(false)
        redirect(Routes.PROFILE)
        break
      case 'logout':
        setUserAnchorEl(false)
        redirect(Routes.LOGOUT)
        break
      case 'change-env':
        setUserAnchorEl(false)
        const demoSystem = systemsJS.find(
          system => system._id === '70586c75ff8b614fa92a2a67de87ae386d19de5c'
        )
        props.showModal({
          type: ModalTypes.EDIT_ENVIRONMENT,
          props: {
            system: demoSystem
          }
        })
        break
      default:
        break
    }
  }

  const helpDropDown = () => {
    const StyledMenu = withStyles(styles.menuHelpPaper)(props => (
      <Menu
        {...props}
        classes={{ paper: styles.menuHelpPaper }}
      />
    ))

    return (
      <div>
        <Button
          disableRipple
          aria-controls='help-menu'
          aria-haspopup='true'
          onClick={handleMenuHelpOpen}
          classes={{ root: { textTransform: 'none' } }}
          className={cx(styles.navItem, styles.buttonLanguages)}
        >
          <Typography variant='subtitle1'>{translate('help')}</Typography>
        </Button>
        <StyledMenu
          elevation={0}
          getContentAnchorEl={null}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right'
          }}
          transformOrigin={{
            vertical: 'bottom',
            horizontal: 'right'
          }}
          id='help-menu'
          anchorEl={helpAnchorEl}
          keepMounted
          open={Boolean(helpAnchorEl)}
          onClose={() => setHelpAnchorEl(null)}
          TransitionComponent={Fade}
        >
          <MenuItem
            key='use-info'
            onClick={() => handleHelpClick('use-info')}
            className={styles.menuItem}
          >
            <Typography>{translate('helpOptions.howMyInbiotWorks')}</Typography>
          </MenuItem>

          <MenuItem
            key='faqs'
            onClick={() => handleHelpClick('faqs')}
            className={styles.menuItem}
          >
            <Typography>{translate('faqs')}</Typography>
          </MenuItem>

          <MenuItem
            key='contact'
            onClick={() => handleHelpClick('contact')}
            className={styles.menuItem}
          >
            <Typography>{translate('helpOptions.contactUs')}</Typography>
          </MenuItem>
        </StyledMenu>
      </div>
    )
  }

  const userDropDown = () => {
    const StyledMenu = withStyles(styles.menuUserPaper)(props => (
      <Menu
        {...props}
        classes={{ paper: styles.menuUserPaper }}
      />
    ))

    return (
      <div>
        <Button
          disableRipple
          aria-controls='user-menu'
          aria-haspopup='true'
          onClick={handleMenuUserOpen}
          classes={{ root: { textTransform: 'none' } }}
          className={cx(styles.navItem, styles.buttonLanguages)}
        >
          <PersonOutlineIcon />
          <Typography variant='subtitle1'>{translate('user')}</Typography>
          {!userAnchorEl && <KeyboardArrowDownIcon />}
          {Boolean(userAnchorEl) && <KeyboardArrowUpIcon />}
        </Button>
        <StyledMenu
          elevation={0}
          getContentAnchorEl={null}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right'
          }}
          transformOrigin={{
            vertical: 'bottom',
            horizontal: 'right'
          }}
          id='user-menu'
          anchorEl={userAnchorEl}
          keepMounted
          open={Boolean(userAnchorEl)}
          onClose={() => setUserAnchorEl(null)}
          TransitionComponent={Fade}
        >
          <MenuItem
            key='edit-profile'
            onClick={() => handleUserClick('edit-profile')}
            className={styles.menuItem}
          >
            <SvgIcon
              className={styles.userOptionsLogo}
              component={ManageAccountsIcon}
              viewBox='0 0 24 24'
            />
            <Typography className={styles.userOptionsText}>{translate('editProfile')}</Typography>
          </MenuItem>

          {user.email === 'demo@orkli.es' && systemsJS.length > 0 && (
            <MenuItem
              key='change-env'
              onClick={() => handleUserClick('change-env')}
              className={styles.menuItem}
            >
              <SvgIcon
                className={styles.userOptionsLogo}
                component={Environment}
                viewBox='0 0 700 700'
              />
              <Typography className={styles.userOptionsText}>{translate('changeEnv')}</Typography>
            </MenuItem>
          )}

          <MenuItem
            key='logout'
            onClick={() => handleUserClick('logout')}
            className={styles.menuItem}
          >
            <ExitToAppOutlinedIcon className={styles.userOptionsLogo} />
            <Typography className={styles.userOptionsText}>{translate('logout')}</Typography>
          </MenuItem>
        </StyledMenu>
      </div>
    )
  }

  const overlay = () => {
    return (
      isMobileMenuOpen && (
        <div
          className={styles.overlay}
          onClick={closeMobileMenu}
        />
      )
    )
  }

  const { isLoggedIn, translate } = props

  return (
    <StylesProvider injectFirst>
      <AppBar className={isLoggedIn ? styles.componentLoggedIn : styles.componentLoggedOut}>
        <Toolbar className={styles.content}>
          <div className={styles.logoWrapper}>
            <Icon className={styles.logo}>
              <img
                className={styles.logoImage}
                src={InbiotLogo}
                alt=''
              />
            </Icon>
          </div>
          <div className={styles.auxHeaderContent}>
            <div className={styles.help}>{helpDropDown()}</div>

            {isLoggedIn && <div className={styles.user}>{userDropDown()}</div>}

            <div className={styles.mobileNav}>
              {helpDropDown()}

              {isLoggedIn && <MenuIcon onClick={openMobileMenu} />}

              <div className={styles.mobileMenu}>{overlay()}</div>
            </div>
          </div>
        </Toolbar>
      </AppBar>
    </StylesProvider>
  )
}

AuxHeader.propTypes = {
  isLoggedIn: PropTypes.bool.isRequired,
  translate: PropTypes.func.isRequired
}

const mapStateToProps = state => ({
  user: getUser(state),
  systems: getSystemsRaw(state),
  userLanguage: getUserLang(state),
  activeLanguage: getActiveLanguage(state.localize),
  languages: getLanguages(state.localize),
  translate: getTranslate(state.localize)
})

const mapActionsToProps = {
  setActiveLanguage,
  showModal,
  hideModal
}

export default withRouter(connect(mapStateToProps, mapActionsToProps)(AuxHeader))
